const replaceAt = (str: string, index: number, newChar: string): string => {
  const replacer = (origChar: string, strIndex: number) => {
    if (strIndex === index) return newChar;
    else return origChar;
  };
  return str.replace(/./g, replacer);
};

export const replacePhoneNumber = (value: string): string => {
  if (value.length) {
    const replaceCharsCount = 3;
    let result = value;
    for (let i = 1; i <= replaceCharsCount; i++) {
      result = replaceAt(result, value.length - (i + 3), "X");
    }
    return result;
  }
  return value;
};
